module.exports = __webpack_public_path__ + "static/media/country_aw.77631130.webp";